<app-navbar></app-navbar>
<div class="content">
  <div class="page-header">
    <h2 itemprop="headline">
      Cookie Policy <br />
      Effective Date: September 2023
    </h2>
  </div>
  <div itemprop="articleBody">
    <span style="color: #686868"><b>Introduction</b></span>

    <p>
      This Cookies Policy explains how HUIOSPAY uses cookies and similar
      technologies on our website and services.
    </p>

    <p style="text-align: justify" align="justify">
      <span style="color: #686868"><b>WHAT ARE COOKIES?</b></span>
    </p>
    <p style="text-align: justify" align="justify">
      <span style="color: #646464"
        >Cookies are small data files that a website sends to your computer or
        mobile device when you visit the site. Cookies allow the website to
        remember your actions and preferences over a period of time, such as
        your login details, language preference, and font size. This means that
        you don't have to keep re-entering your information each time you visit
        the site or browse from page to page.</span
      >
    </p>
    <p style="text-align: justify" align="justify">
      <span style="color: #686868"
        ><b>What types of cookies do we use?</b></span
      >
    </p>
    <p style="text-align: justify" align="justify">
      <span style="color: #646464"
        >We use the following types of cookies on our Services:</span
      >
    </p>
    <p style="text-align: justify" align="justify">
      <b>Essential cookies: </b>
      <span style="color: #646464"
        >These cookies are necessary for the Services to function properly. They
        allow you to move around the website and use certain features, such as
        logging in and accessing secure areas.</span
      >
    </p>
    <p style="text-align: justify" align="justify">
      <b>Performance cookies: </b>
      <span style="color: #646464">
        These cookies collect information about how you use our Services, such
        as which pages you visit most often and whether you encounter any error
        messages. This information helps us improve the Services by identifying
        and fixing problems.</span
      >
    </p>
    <p style="text-align: justify" align="justify">
      <b>Functional cookies: </b>
      <span style="color: #646464">
        These cookies allow us to remember your preferences, such as your
        language preference and location. This helps us to provide you with a
        more personalized experience.
      </span>
    </p>
    <p style="text-align: justify" align="justify">
      <b>Targeting or advertising cookies: </b>
      <span style="color: #646464">
        These cookies are used to deliver advertisements that are more relevant
        to you and your interests. They may also be used to limit the number of
        times you see an advertisement and to measure the effectiveness of
        advertising campaigns.
      </span>
    </p>

    <p style="text-align: justify" align="justify"></p>
    <p style="text-align: justify" align="justify">
      <span style="color: #686868"><b>How do we use cookies?</b></span>
    </p>

    <p style="text-align: justify" align="justify">
      <span style="color: #646464"
        >We use cookies for a variety of purposes, including:</span
      >
    </p>

    <p style="text-align: justify" align="justify">
      <b>Authentication: </b>
      <span style="color: #646464">
        We use cookies to recognize you when you visit our website and log in,
        ensuring a smooth and secure user experience.
      </span>
    </p>

    <p style="text-align: justify" align="justify">
      <b>Keeping you logged in: </b>
      <span style="color: #646464">
        If you are logged in to our Services, we will use cookies to keep you
        logged in and to remember your preferences, such as your language
        preference and location.
      </span>
    </p>

    <p style="text-align: justify" align="justify">
      <b>Personalizing your experience: </b>
      <span style="color: #646464">
        We use cookies to personalize your experience on our Services. For
        example, we may use cookies to remember your preferences, such as your
        language preference and location.
      </span>
    </p>

    <p style="text-align: justify" align="justify">
      <b>Analyzing website traffic: </b>
      <span style="color: #646464">
        We use cookies to analyze website traffic. This information helps us
        improve the Services by identifying and fixing problems.
      </span>
    </p>

    <p style="text-align: justify" align="justify">
      <b>Serving advertising/Marketing: </b>
      <span style="color: #646464">
        We use cookies to serve advertising that is more relevant to you and
        your interests.
      </span>
    </p>

    <p style="text-align: justify" align="justify"></p>
    <p style="text-align: justify" align="justify">
      <span style="color: #686868"><b>How long do we keep cookies?</b></span>
    </p>
    <p style="text-align: justify" align="justify">
      <span style="color: #686868">
        We keep cookies for different lengths of time depending on the type of
        cookie. For example, essential cookies are typically only kept for the
        duration of your session on our Services, while performance cookies may
        be kept for a longer period of time.
      </span>
    </p>

    <p style="text-align: justify" align="justify">
      <span style="color: #686868"><b>How can I control cookies? </b></span>
    </p>
    <p style="text-align: justify" align="justify">
      <span style="color: #686868"
        >You can control cookies in a number of ways, including:</span
      >
    </p>

    <!-- <p style="text-align: justify" align="justify">
      <span style="color: #686868">Cookies can be divided into: </span>
    </p> -->
    <ul style="text-align: justify">
      <li>
        <span style="color: #686868"
          ><b>Deleting cookies:</b> You can delete cookies from your computer or
          mobile device at any time. However, this may mean that you lose some
          of your preferences and settings.</span
        >
      </li>
      <li>
        <span style="color: #686868"
          ><b>Blocking cookies:</b>
          You can block cookies by changing the settings on your computer or
          mobile device. However, this may mean that you are unable to access
          certain features of our Services.
        </span>
      </li>
      <li>
        <span style="color: #686868"
          ><b>Managing cookies:</b> You can manage cookies using a variety of
          tools and plugins. For example, you can install the Ghostery plugin to
          block tracking cookies.
        </span>
      </li>
      <li>
        <span style="color: #686868"
          ><b>Browser Settings:</b> You can usually set your browser to refuse
          cookies or alert you when cookies are being sent. However, some parts
          of our website may not function properly without cookies.
        </span>
      </li>
      <li>
        <span style="color: #686868"
          ><b>Opt-Out:</b> You can opt out of targeted advertising by using the
          tools provided by ad networks or through the settings in your browser.
        </span>
      </li>
    </ul>

    <p style="text-align: justify" align="justify">
      <span style="color: #686868"><b>Changes to this Cookies Policy</b></span>
    </p>
    <p style="text-align: justify" align="justify">
      <span style="color: #646464">
        We may update this Cookies Policy from time to time. We will notify you
        of any material changes by posting the updated Cookies Policy on our
        website to reflect changes in our practices or for other operational,
        legal, or regulatory reasons.</span
      >
    </p>
    <p style="text-align: justify" align="justify">
      <span style="color: #686868"><b>Contact Us</b></span>
    </p>
    <p style="text-align: justify" align="justify">
      <span style="color: #646464">
        If you have any questions about this Cookies Policy, please contact us
        at <a href="mailto:contactus@huiospay.com">[contactus@huiospay.com]</a>
      </span>
    </p>

    <p style="text-align: justify" align="justify">
      <span style="color: #686868"><b>Additional Information</b></span>
    </p>
    <p style="text-align: justify" align="justify">
      <span style="color: #646464">
        For more information on how we process your personal data, please refer to our Privacy Policy. 
      </span>
    </p>

    <!-- <p style="text-align: justify" align="justify">
      <span style="color: #686868"
        >Follows the list of configuration panels of the most famous
        browsers:</span
      >
    </p>
    <table border="medium none" width="100%" cellspacing="0" cellpadding="10px">
      <tbody>
        <tr>
          <td style="border: none" width="10%" height="17">
            <p>
              <span style="color: #686868"><b>Chrome </b></span>
            </p>
          </td>
          <td style="border: none" width="90%">
            <p style="margin-bottom: 0cm">
              <span style="color: #686868">Visit the dedicated page</span>
            </p>
            <p>
              <span style="color: #686868"
                >(<a
                  href="https://support.google.com/chrome/bin/answer.py?hl=en&amp;answer=95647&amp;p=cpn_cookies"
                  target="_blank"
                  rel="noopener noreferrer"
                  >https://support.google.com/chrome/bin/answer.py?hl=en&amp;answer=95647&amp;p=cpn_cookies</a
                >)</span
              >
            </p>
          </td>
        </tr>
        <tr>
          <td style="border: none" bgcolor="#ededed" width="10%" height="17">
            <p>
              <span style="color: #686868"><b>Mozilla Firefox </b></span>
            </p>
          </td>
          <td style="border: none" bgcolor="#ededed" width="90%">
            <p style="margin-bottom: 0cm">
              <span style="color: #686868">Visit the dedicated page</span>
            </p>
            <p>
              <span style="color: #686868"
                >(<a
                  href="http://support.mozilla.org/en-US/kb/Enabling%20and%20disabling%20cookies"
                  target="_blank"
                  rel="noopener noreferrer"
                  >http://support.mozilla.org/en-US/kb/Enabling%20and%20disabling%20cookies</a
                >)</span
              >
            </p>
          </td>
        </tr>
        <tr>
          <td style="border: none" width="10%" height="17">
            <p>
              <span style="color: #686868"><b>Internet Explorer </b></span>
            </p>
          </td>
          <td style="border: none" width="90%">
            <p style="margin-bottom: 0cm">
              <span style="color: #686868">Visit the dedicated page</span>
            </p>
            <p>
              <span style="color: #686868"
                >(<a
                  href="http://windows.microsoft.com/en-us/windows-vista/block-or-allow-cookies"
                  target="_blank"
                  rel="noopener noreferrer"
                  >http://windows.microsoft.com/en-us/windows-vista/block-or-allow-cookies</a
                >)</span
              >
            </p>
          </td>
        </tr>
        <tr>
          <td style="border: none" bgcolor="#ededed" width="10%" height="17">
            <p>
              <span style="color: #686868"><b>Microsoft Edge </b></span>
            </p>
          </td>
          <td style="border: none" bgcolor="#ededed" width="90%">
            <p style="margin-bottom: 0cm">
              <span style="color: #686868">Visit the dedicated page</span>
            </p>
            <p>
              <span style="color: #686868">(</span
              ><a
                href="https://privacy.microsoft.com/it-IT/windows-10-microsoft-edge-and-privacy"
                target="_blank"
                rel="noopener noreferrer"
                ><span style="color: #003575"
                  >https://privacy.microsoft.com/it-IT/windows-10-microsoft-edge-and-privacy</span
                ></a
              ><span style="color: #686868">)</span>
            </p>
          </td>
        </tr>
        <tr>
          <td style="border: none" width="10%" height="17">
            <p>
              <span style="color: #686868"><b>Safari 6 </b></span>
            </p>
          </td>
          <td style="border: none" width="90%">
            <p style="margin-bottom: 0cm">
              <span style="color: #686868">Visit the dedicated page</span>
            </p>
            <p>
              <span style="color: #686868"
                >(<a
                  href="https://support.apple.com/it-it/HT201265"
                  target="_blank"
                  rel="noopener noreferrer"
                  >https://support.apple.com/it-it/HT201265</a
                >)</span
              >
            </p>
          </td>
        </tr>
        <tr>
          <td style="border: none" bgcolor="#ededed" width="10%" height="39">
            <p>
              <span style="color: #686868"><b>Safari iOS </b></span
              ><span style="color: #686868"
                ><br />
                (mobile)</span
              >
            </p>
          </td>
          <td style="border: none" bgcolor="#ededed" width="90%">
            <p style="margin-bottom: 0cm">
              <span style="color: #686868">Visit the dedicated page</span>
            </p>
            <p>
              <span style="color: #686868"> (</span
              ><a
                href="https://support.apple.com/en-us/HT201265"
                target="_blank"
                rel="noopener noreferrer"
                ><span style="color: #003575"
                  >https://support.apple.com/en-us/HT201265</span
                ></a
              ><span style="color: #686868">)</span>
            </p>
          </td>
        </tr>
        <tr>
          <td style="border: none" width="10%" height="17">
            <p>
              <span style="color: #686868"><b>Opera </b></span>
            </p>
          </td>
          <td style="border: none" width="90%">
            <p style="margin-bottom: 0cm">
              <span style="color: #686868">Visit the dedicated page</span>
            </p>
            <p>
              <span style="color: #686868"
                >(<a
                  href="http://help.opera.com/Windows/10.00/it/cookies.html"
                  target="_blank"
                  rel="noopener noreferrer"
                  >http://help.opera.com/Windows/10.00/it/cookies.html</a
                >)</span
              >
            </p>
          </td>
        </tr>
      </tbody>
    </table> -->
    <p align="justify"></p>
    <p align="justify">
      <span style="color: #686868"><b>ALLOW AND REJECTION OF COOKIES</b></span>
    </p>
    <p align="justify" style="margin-bottom: 100px">
      <span style="color: #686868"
        >Keeping on browsing on this website or closing the info box or clicking
        anywhere in the page, you accept Cookie Policy and cookies will start to
        be set and collected. In case of refusal closing the webpage, cookies
        already collected on your browser will remain stored but they will not
        be read or used anymore until you accept the Cookies Policy. You will be
        always able to disable cookies at any time, using the abovementioned
        procedure.</span
      >
    </p>
  </div>
</div>
<app-footer></app-footer>
